import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_APP_VERSION_REQUEST = 'AppVersion/FETCH_APP_VERSION_REQUEST'
const FETCH_APP_VERSION_SUCCESS = 'AppVersion/FETCH_APP_VERSION_SUCCESS'
const FETCH_APP_VERSION_FAILURE = 'AppVersion/FETCH_APP_VERSION_FAILURE'

const FETCH_APP_VERSION_BY_ID_REQUEST =
  'AppVersion/FETCH_APP_VERSION_BY_ID_REQUEST'
const FETCH_APP_VERSION_BY_ID_SUCCESS =
  'AppVersion/FETCH_APP_VERSION_BY_ID_SUCCESS'
const FETCH_APP_VERSION_BY_ID_FAILURE =
  'AppVersion/FETCH_APP_VERSION_BY_ID_FAILURE'

const CREATE_APP_VERSION_REQUEST = 'AppVersion/CREATE_APP_VERSION_REQUEST'
const CREATE_APP_VERSION_SUCCESS = 'AppVersion/CREATE_APP_VERSION_SUCCESS'
const CREATE_APP_VERSION_FAILURE = 'AppVersion/CREATE_APP_VERSION_FAILURE'

const UPDATE_APP_VERSION_REQUEST = 'AppVersion/UPDATE_APP_VERSION_REQUEST'
const UPDATE_APP_VERSION_SUCCESS = 'AppVersion/UPDATE_APP_VERSION_SUCCESS'
const UPDATE_APP_VERSION_FAILURE = 'AppVersion/UPDATE_APP_VERSION_FAILURE'

const DELETE_APP_VERSION_REQUEST = 'AppVersion/DELETE_APP_VERSION_REQUEST'
const DELETE_APP_VERSION_SUCCESS = 'AppVersion/DELETE_APP_VERSION_SUCCESS'
const DELETE_APP_VERSION_FAILURE = 'AppVersion/DELETE_APP_VERSION_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  appVersionList: [],
  appVersionObj: {}
}

// Default Reducer
const appVersion = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_APP_VERSION_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_APP_VERSION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        appVersionList: action.payload
      }
    case FETCH_APP_VERSION_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_APP_VERSION_BY_ID_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_APP_VERSION_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        appVersionObj: action.payload
      }
    case FETCH_APP_VERSION_BY_ID_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_APP_VERSION_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_APP_VERSION_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_APP_VERSION_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_APP_VERSION_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_APP_VERSION_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_APP_VERSION_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_APP_VERSION_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_APP_VERSION_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_APP_VERSION_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }
}

export default appVersion

// Action Creators
export const fetchAppVersionList = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_APP_VERSION_REQUEST
      })

      const response = await API.get(EndPoints.APP_VERSION + '/all')
      dispatch({
        type: FETCH_APP_VERSION_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_APP_VERSION_FAILURE
      })
    }
  }
}

export const createAppVersion = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_APP_VERSION_REQUEST
      })

      await API.post(EndPoints.APP_VERSION, data)
      dispatch({
        type: CREATE_APP_VERSION_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_APP_VERSION_FAILURE
      })
    }
  }
}

export const updateAppVersion = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_APP_VERSION_REQUEST
      })

      await API.put(EndPoints.APP_VERSION, data)
      dispatch({
        type: UPDATE_APP_VERSION_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_APP_VERSION_FAILURE
      })
    }
  }
}

export const deleteAppVersion = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_APP_VERSION_REQUEST
      })

      await API.delete(EndPoints.APP_VERSION + `/${id}`)
      dispatch({
        type: DELETE_APP_VERSION_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_APP_VERSION_FAILURE
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/appVersion.js